import { Controller } from "@hotwired/stimulus"
import data from "@emoji-mart/data"

// Display glyphs independently of Emoji Mart's non-reconnectable custom elements.
export default class extends Controller {
  static values = { id: String }

  initialize() {
    this.renderAfterMorph = this.render.bind(this)
  }

  connect() {
    this.element.addEventListener("turbo:morph-element", this.renderAfterMorph)
    this.render()
  }

  disconnect() {
    this.element.removeEventListener("turbo:morph-element", this.renderAfterMorph)
  }

  idValueChanged() {
    this.render()
  }

  render() {
    const id = data.aliases[this.idValue] || this.idValue
    this.element.textContent = data.emojis[id]?.skins[0]?.native || this.idValue
  }
}
